module.exports = __webpack_public_path__ + "img/banner2.0692b3a2.jpg";